module.exports = __webpack_public_path__ + "media/images/sp/header/visit-e17e4fac099d078a216810a191f4b339.svg";